import styles from "./UserNotifications.module.scss";
import { NotificationIcon } from "../../../../assets/icons/NotificationIcon";
import { useUserNotifications } from "./useUserNotifications";
import classNames from "classnames";
import { format } from "timeago.js";
import ContentBodyLoader from "../../MetadataSummary/Content/ContentBody/ContentBodyLoader";
import VLPopover from "../../../uikit/VLPopover";
import { Badge } from "antd";
import VLTooltip from "../../../uikit/VLTooltip";
import { useState } from "react";

export const UserNotifications = ({
  className,
  datasetId,
}: {
  datasetId: string;
  className: string;
}) => {
  const {
    notifications,
    isLoading,
    unreadCount,
    markAllRead,
    handleNotificationClick,
  } = useUserNotifications(datasetId);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const handlePopoverOpenChange = (open: boolean) => {
    setIsPopoverOpen(open);
    if (!open) {
      markAllRead();
    }
  };

  return (
    <VLPopover
      arrow={false}
      placement="bottomRight"
      trigger="click"
      bordered
      onOpenChange={handlePopoverOpenChange}
      content={
        <NotificationsList
          handleNotificationClick={handleNotificationClick}
          notifications={notifications}
          isLoading={isLoading}
        />
      }
    >
      <VLTooltip title={isPopoverOpen ? null : "Alerts"}>
        <div className={classNames(styles.iconWrapper, className)}>
          <Badge count={unreadCount} className={styles.count}>
            <NotificationIcon />
          </Badge>
        </div>
      </VLTooltip>
    </VLPopover>
  );
};

const NotificationsList = ({
  notifications,
  isLoading,
  handleNotificationClick,
}: Pick<
  ReturnType<typeof useUserNotifications>,
  "handleNotificationClick" | "isLoading" | "notifications"
>) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>Monitor Alerts</div>
      {isLoading ? (
        <ContentBodyLoader center size={48} />
      ) : !notifications.length ? (
        <div className={styles.emptyMessage}>No alerts</div>
      ) : (
        <div className={styles.list}>
          {notifications.map((notification) => (
            <div
              onClick={() => handleNotificationClick(notification)}
              className={classNames(styles.item, {
                [styles.unread]: !notification.read_at,
              })}
              key={notification.id}
            >
              <NotificationIcon className={styles.icon} />
              <div className={styles.details}>
                <div className={styles.name}>
                  {notification.metadata!.view_name}
                </div>
                <div className={styles.description}>
                  New results were detected
                </div>
                <div className={styles.time}>
                  {format(new Date(notification.created_at + "Z"))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
